import { render } from "./EconomyStatusTables.vue?vue&type=template&id=5a1996b0&ts=true"
import script from "./EconomyStatusTables.vue?vue&type=script&lang=ts"
export * from "./EconomyStatusTables.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__